import { NoDataEvent, EWidgetState } from "app/pages/website-analysis/demographics/services/NoDataEvent";

const DemographicsUserBasedWidgets = ["gender", "age", "traffic and engagement table"] as const;
export class DemographicsUserBasedNoDataEvent extends NoDataEvent<typeof DemographicsUserBasedWidgets> {
    static classInstance;
    constructor() {
        super();
        if (!DemographicsUserBasedNoDataEvent.classInstance) {
            this.widgets = {
                age: EWidgetState.INITIAL,
                gender: EWidgetState.INITIAL,
                "traffic and engagement table": EWidgetState.INITIAL,
            };
            DemographicsUserBasedNoDataEvent.classInstance = this;
        }
        return DemographicsUserBasedNoDataEvent.classInstance;
    }
}
